/* -----------------Globals--------------- */
import { router, useLocalSearchParams } from "expo-router";
import { useState } from "react";

import { proethicaOnboardingConfig } from "@constants/demo/praxis-proethica";
import { getProethicaModuleTags } from "@features/dashboard/helpers/proethica-module-list";
import { useSession } from "@features/session";
import { useDemoExamStore } from "@hooks/useDemoExamStore";
import { useGlobalStore } from "@hooks/useGlobalStore";
import useMixedItemDist from "@hooks/useMixedItemDist";
import { ChooseCategoryContainer } from "../screens/ChooseCategoryContainer";
/* -----------------Child components--------------- */
import ChooseDateContainer from "../screens/ChooseDateContainer";
import { ChooseExamContainer } from "../screens/ChooseExamContainer";
import { RedeemContainer } from "../screens/RedeemContainer";
import ProethicaOnboardingFlow from "./ProethicaOnboardingFlow";

/* -----------------UI--------------- */
import { Box } from "@memorang/ui";

const OnboardingRouteContainer = () => {
	const searchParams = useLocalSearchParams();
	const demoExamId = useDemoExamStore((state) => state.currentExam.id);
	const setHasCompletedProethicaOnboarding = useGlobalStore(
		(state) => state.setHasCompletedProethicaOnboarding,
	);
	const { handleDirectSessionStart } = useSession();
	const { data: mixedItemDist } = useMixedItemDist(
		demoExamId === "proethica" && proethicaOnboardingConfig.enabled,
	);
	const [proethicaStepIndex, setProethicaStepIndex] = useState(0);

	const step = (searchParams?.step || "category") as string;
	const handleUpdateParam = (newStep: string) => {
		router.setParams({
			step: newStep,
		});
	};

	const comps: Record<string, React.ReactNode> = {
		chooseexam: <ChooseExamContainer handleNext={handleUpdateParam} />,
		userdetails: <ChooseDateContainer />,
		redeem: (
			<RedeemContainer
				handleNext={() => {
					handleUpdateParam("category");
				}}
			/>
		),
		category: <ChooseCategoryContainer />,
	};

	if (demoExamId === "proethica" && proethicaOnboardingConfig.enabled) {
		const handleStartModuleOne = () => {
			setHasCompletedProethicaOnboarding(true);

			// Without a collectionId, live create-session falls back to the default module.
			const firstModule = getProethicaModuleTags(mixedItemDist?.exams)[0];

			if (!firstModule) {
				router.push("/modules");
				return;
			}

			handleDirectSessionStart({ moduleId: firstModule.id });
		};

		return (
			<ProethicaOnboardingFlow
				config={proethicaOnboardingConfig}
				activeStepIndex={proethicaStepIndex}
				onStepChange={setProethicaStepIndex}
				onStartModuleOne={handleStartModuleOne}
			/>
		);
	}

	return <Box flex={1}>{comps[step]}</Box>;
};

export default OnboardingRouteContainer;
